import { render, staticRenderFns } from "./content.vue?vue&type=template&id=3e657eed&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e657eed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e657eed')) {
      api.createRecord('3e657eed', component.options)
    } else {
      api.reload('3e657eed', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=3e657eed&scoped=true&", function () {
      api.rerender('3e657eed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/book/content.vue"
export default component.exports